import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, CreditCard, TrendingUp, Building2, Coins } from 'lucide-react';
import { clsx } from 'clsx';

const navItems = [
  { id: 'home', label: 'Home', icon: Home, path: '/' },
  { id: 'smartpay', label: 'SmartPay', icon: CreditCard, path: '/smartpay' },
  { id: 'trade', label: 'Trade', icon: TrendingUp, path: '/trade' },
  { id: 'b2b', label: 'B2B', icon: Building2, path: '/b2b' },
  { id: 'assets', label: 'Assets', icon: Coins, path: '/assets' },
];

export const BottomNavigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2 safe-area-pb">
      <div className="flex justify-around items-center max-w-md mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={clsx(
                'flex flex-col items-center justify-center p-2 rounded-lg transition-colors',
                isActive
                  ? 'text-primary-600'
                  : 'text-gray-500 hover:text-gray-700'
              )}
            >
              <Icon size={20} className="mb-1" />
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};